module.exports = __webpack_public_path__ + "img/bus-1.b047f6ee.jpg";